const tabEquip = {
  equip: 'EQUIPAMENTO',
  service: 'SERVIÇOS',
  action: 'AÇÕES',
  attachFiles: 'ANEXOS',
  maintenance: 'MANUTENÇÃO',
  equipFinance: 'FINANCEIRO',
};

export default tabEquip;
